const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const TIME_ONLY_REGEX = /^\d{2}:\d{2}(:\d{2})?$/;

export const isDateOnlyString = (value) =>
  typeof value === "string" && DATE_ONLY_REGEX.test(value);

export const parseDateValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (isDateOnlyString(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const isValidDate = (value) => {
  const date = parseDateValue(value);
  return Boolean(date);
};

export const formatDate = (value, locale = "en-US") => {
  if (!isValidDate(value)) return "";

  const date = parseDateValue(value);

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
};

export const formatShortDate = (value, locale = "en-US") => {
  if (!isValidDate(value)) return "";

  const date = parseDateValue(value);

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(date);
};

export const formatMonthYear = (value, locale = "en-US") => {
  if (!isValidDate(value)) return "";

  const date = parseDateValue(value);

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long",
  }).format(date);
};

export const formatDateForApi = (value) => {
  if (!value) return "";

  if (isDateOnlyString(value)) {
    return value;
  }

  const date = parseDateValue(value);
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatTime = (value, locale = "en-US") => {
  if (!value) return "";

  if (typeof value === "string" && TIME_ONLY_REGEX.test(value)) {
    const [hours, minutes] = value.split(":");
    const date = new Date(2000, 0, 1, Number(hours), Number(minutes), 0, 0);

    return new Intl.DateTimeFormat(locale, {
      hour: "numeric",
      minute: "2-digit",
    }).format(date);
  }

  const date = parseDateValue(value);
  if (!date) return "";

  return new Intl.DateTimeFormat(locale, {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
};

export default formatDate;